export default __webpack_public_path__ + "static/l5-case1-f745d48a5882ff8182a3aab1b875ee9d.jpg";